import { createSelector } from 'reselect';

export const getById = ({ rawMatSupplier }) => rawMatSupplier.byId;
export const getIds = ({ rawMatSupplier }) => rawMatSupplier.list.allIds;

export const getRawMatSupplierList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
